import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import { ActivatedRoute, Params, Router } from "@angular/router";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { UserProfile } from "src/app/parametrage/core/model/user-profile";
import { UserProfileService } from "src/app/parametrage/core/service/user-profile.service";
import { EmployeeService } from "src/app/parametrage/core/service/employee.service";
import { Employee } from "src/app/parametrage/core/model/employee/employee";
import { RetournerDossier } from "src/app/mon-portefeuille/core/model/retourner-dossier";
import { RequestService } from "src/app/parametrage/core/service/request.service";
import { Request } from "src/app/parametrage/core/model/request";
import { CorrectionHistoryService } from "src/app/mon-portefeuille/core/service/correction-history.service";

@Component({
  selector: "app-retourner-dossier-modal",
  templateUrl: "./retourner-dossier-modal.component.html",
  styleUrls: ["./retourner-dossier-modal.component.scss"],
})
export class RetournerDossierModalComponent implements OnInit {
  @Input() requestId;

  form2: FormGroup;
  pressButton: Boolean = false;

  request: Request;

  userProfiles: UserProfile[];
  employees: Employee[];

  command: RetournerDossier = new RetournerDossier();

  errorMessage: String = null;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private _employeeService: EmployeeService,
    private _userProfileService: UserProfileService,
    private _requestService: RequestService,
    private _correctionHistoryService: CorrectionHistoryService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      roleAffected: [null, Validators.compose([Validators.required])],
      userAffected: [null, Validators.compose([Validators.required])],
      motif: [null, Validators.compose([Validators.required])],
    });
  }

  ngOnInit() {
    this.getUserProfiles();
    this.getRequestById(this.requestId);
  }

  getUserProfiles() {
    this._userProfileService.getUserProfiles().subscribe(
      (data) => {
        this.userProfiles = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getUsers() {
    const roleId = this.form2.value.roleAffected;
    this._employeeService.getEmployeeByProfile(roleId).subscribe(
      (data) => {
        this.employees = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getRequestById(requestId) {
    this._requestService.getRequestById(requestId).subscribe(
      (data) => {
        this.request = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  retourner(): void {
    this.pressButton = true;
    this.command.requestId = this.requestId;
    this._correctionHistoryService
      .retourner(this.command)
      .pipe(first())
      .subscribe(
        (data) => {
          this.activeModal.close();
          this._router.navigate(["/mon-portefeuille/mes-dossiers"]);
        },
        (error) => {
          console.log(error);
          this.errorMessage = error.error.message;
        }
      );
  }
}
